import React from "react";
import "./Why_Choose.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";

const Why_Choose = () => {
  return (
    <section className="Why_Choose">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="left_side">
              <Heading_title title={"Why Choose Us?"} />

              <div className="heading_div">
                <p className="second_heading_text">
                  <span className="green_text">Choose Us </span>for
                </p>
                <p className="second_heading_text">Accuracy & Reliability</p>
              </div>

              <p className="simple_text">
                At Scroma Venture, we believe an organization's strength lies in
                its employees. We view our team as the foundation of our values.
                It's the motivated professional who guarantees customer
                satisfaction, upholds quality standards, & drives us toward
                success.
              </p>

              <p className="simple_text">
                Therefore, we foster a culture of leadership to ensure our
                employees are always prepared for business challenges. We are
                committed to the well-being of our workforce, proactively
                offering support and being there for them at every step. They
                aren't just staff; they're our extended family.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="img_div">
              <img
                src="/assets/images/about_us/why_choose/img1.png"
                className="machine_img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Choose;
